module.exports = __webpack_public_path__ + "media/images/plans/plan-kaihikon-5f967278351ce089ad5cf6a5c1bc966b.jpg";